import styled from "styled-components";
import { Colors, Text } from "../../../config/Constants";
import YachtRegistrationHistoryTable from "./YachtRegistrationHistoryTable";

interface YachtClubHistoryProps {
  data: {
    id: string;
    name: string;
    phone: string;
    parkingSpot: string;
    loam: string;
    package: string;
    startDate: string;
    expiryDate: string;
    status: string;
    additionalService: boolean;
  }[];
  isTableDataLoading: boolean;
  totalData: number;
  currentPage: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
}

const YachtRegistrationHistory = ({
  data,
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  onPageChange,
}: YachtClubHistoryProps) => {
  return (
    <YachtRegistrationHistoryWrapper>
      <StyledPageHeader>{Text.yachtRegistrationHistoryHeader}</StyledPageHeader>
      <YachtRegistrationHistoryTable
        isTableDataLoading={isTableDataLoading}
        data={data}
        totalData={totalData}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
      />
    </YachtRegistrationHistoryWrapper>
  );
};

export const YachtRegistrationHistoryWrapper = styled.div`
  margin-top: 5rem;
  @media only screen and (max-width: 768px) {
    margin-top: 3rem;
  }
`;

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  font-weight: 500;
  line-height: 1.75rem;
  padding-bottom: 1.25rem;
  color: ${Colors.black};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export default YachtRegistrationHistory;
